import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import TopHeader from "./components/TopHeader";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <TopHeader />
    <App />
    <div className="bg-black flex flex-col space-y-2 py-10 px-4 md:hidden">
      <h3 className="text-white text-lg font-semibold mb-2">Useful Links</h3>

      <a
        href="https://www.lenostube.com/en/shop"
        style={{ color: "#ebebeb" }}
        className="hover:underline"
      >
        Homepage
      </a>

      <a
        href="https://www.lenostube.com/en/shop"
        style={{ color: "#ebebeb" }}
        className="hover:underline"
      >
        More Services
      </a>

      <a
        href="https://www.lenostube.com/en/all-tools"
        style={{ color: "#ebebeb" }}
        className="hover:underline"
      >
        Free Tools
      </a>

      <a
        href="https://www.lenostube.com/en/blog"
        style={{ color: "#ebebeb" }}
        className="hover:underline"
      >
        Blog
      </a>

      <a
        href="https://www.lenostube.com/en/terms-conditions-of-sale"
        style={{ color: "#ebebeb" }}
        className="hover:underline"
      >
        Terms
      </a>
      <a
        href="mailto:info@lenostube.com"
        style={{ color: "#ebebeb" }}
        className="hover:underline"
      >
        info@lenostube.com
      </a>
    </div>

    <div className="bg-gray-800 flex justify-center">
      <div className=" px-4 md:px-12 py-6 md:py-2 w-full md:w-2/3 flex flex-col md:flex-row justify-center gap-y-4 md:gap-y-0 space-between items-center h-auto md:h-20 ">
        <div className="w-full md:w-2/5">
          <p className="text-white text-xs md:text-sm ml-auto text-center ">
            © 2018-2024 Lenos · Rights reserved
          </p>
        </div>
        <div className="w-full md:w-2/5 flex justify-center text-white ">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            width="20"
            height="20"
            style={{ marginRight: 10 }}
          >
            <path
              d="M19 10H20C20.5523 10 21 10.4477 21 11V21C21 21.5523 20.5523 22 20 22H4C3.44772 22 3 21.5523 3 21V11C3 10.4477 3.44772 10 4 10H5V9C5 5.13401 8.13401 2 12 2C15.866 2 19 5.13401 19 9V10ZM5 12V20H19V12H5ZM11 14H13V18H11V14ZM17 10V9C17 6.23858 14.7614 4 12 4C9.23858 4 7 6.23858 7 9V10H17Z"
              fill="rgba(255,255,255,1)"
            ></path>
          </svg>
          <div>
            <p className="text-xs md:text-sm  bold">SSL Secure Payment</p>

            <p className="text-xs">
              Your payment is protected by 256-bit SSL encryption.
            </p>
          </div>
        </div>

        <div className="w-full md:w-2/5 flex justify-evenly">
          <img
            height="28"
            width="28"
            src="https://cdn.simpleicons.org/visa/white"
            class="perfmatters-lazy entered pmloaded"
            data-src="https://cdn.simpleicons.org/visa/white"
            data-ll-status="loaded"
            alt="Visa"
          />
          <img
            height="26"
            width="26"
            src="https://cdn.simpleicons.org/mastercard/white"
            class="perfmatters-lazy entered pmloaded"
            data-src="https://cdn.simpleicons.org/mastercard/white"
            data-ll-status="loaded"
            alt="Mastercard"
          />
          <img
            height="20"
            width="20"
            src="https://cdn.simpleicons.org/americanexpress/white"
            class="perfmatters-lazy entered pmloaded"
            data-src="https://cdn.simpleicons.org/americanexpress/white"
            data-ll-status="loaded"
            alt="American Express"
          />
          <img
            height="20"
            width="20"
            src="https://cdn.simpleicons.org/stripe/white"
            class="perfmatters-lazy entered pmloaded"
            data-src="https://cdn.simpleicons.org/stripe/white"
            data-ll-status="loaded"
            alt="Stripe"
          />
          <img
            height="20"
            width="20"
            src="https://cdn.simpleicons.org/bitcoin/white"
            class="perfmatters-lazy entered pmloaded"
            data-src="https://cdn.simpleicons.org/bitcoin/white"
            data-ll-status="loaded"
            alt="Bitcoin"
          />
        </div>
      </div>
    </div>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
